import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserRole, login } from "../services/authService";
import "../styles/login.css"

const Login: React.FC = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        const response = await login({ email, password });
        if (response && !response.isError) {
          setEmail("");
          setPassword("");
          navigate("/");
          window.location.reload();
        } else {
          alert("Login failed");
        }
      };

    return (
      <div className="login-container-box">
        <div className="login-container mt-10 text-center">
          <h2 className="text-xl font-bold mb-4 title">Login</h2>
          <form onSubmit={handleLogin} className="flex flex-col gap-4 items-center">
          <input
              type="email"
              placeholder="Email"
              className="border p-2 w-64"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
          />
          <input
              type="password"
              placeholder="Password"
              className="border p-2 w-64"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
          />
          <button className="submit-button bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600" type="submit">
              Sign In
          </button>
          </form>
        </div>
      </div>
    );
};

export default Login;